<template>
  <div class="circuit-detail-map-image" :class="`circuit-detail-map-image--mode-${gpsViewMode}`">
    <circuit-map-image-auto-police
      v-if="circuitName === 'AUTOPOLIS'"
      class="circuit-detail-map-image__svg"
    />
    <circuit-map-image-fuji
      v-else-if="circuitName === 'FUJI_SPEEDWAY'"
      class="circuit-detail-map-image__svg"
    />
    <circuit-map-image-motegi
      v-else-if="circuitName === 'TWIN_RING_MOTEGI'"
      class="circuit-detail-map-image__svg"
    />
    <circuit-map-image-sugo
      v-else-if="circuitName === 'SPORTSLAND_SUGO'"
      class="circuit-detail-map-image__svg"
    />
    <circuit-map-image-suzuka
      v-else-if="circuitName === 'SUZUKA_CIRCUIT'"
      class="circuit-detail-map-image__svg"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import { GpsViewModeType } from '@/components/RaceVideoPage/RaceVideoGpsPane.vue'
import CircuitMapImageAutoPolice from '@/components/RaceVideoPage/RaceVideoGpsPane/parts/CircuitMapImageAutoPolice.vue'
import CircuitMapImageFuji from '@/components/RaceVideoPage/RaceVideoGpsPane/parts/CircuitMapImageFuji.vue'
import CircuitMapImageMotegi from '@/components/RaceVideoPage/RaceVideoGpsPane/parts/CircuitMapImageMotegi.vue'
import CircuitMapImageSugo from '@/components/RaceVideoPage/RaceVideoGpsPane/parts/CircuitMapImageSugo.vue'
import CircuitMapImageSuzuka from '@/components/RaceVideoPage/RaceVideoGpsPane/parts/CircuitMapImageSuzuka.vue'
import { CourseType } from '@/store/stores/collectionModule/documents/championship/ChampionshipDocument'

/**
 * レース動画再生画面: GPS詳細 マップ表示 コンポーネント
 */
export default defineComponent({
  name: 'CircuitDetailMapImage',
  components: {
    CircuitMapImageAutoPolice,
    CircuitMapImageFuji,
    CircuitMapImageMotegi,
    CircuitMapImageSugo,
    CircuitMapImageSuzuka,
  },
  props: {
    /**
     * GPS表示モード
     */
    circuitName: {
      type: String as PropType<CourseType>,
      required: true,
    },
    /**
     * GPS表示モード
     */
    gpsViewMode: {
      type: String as PropType<GpsViewModeType>,
      default: 'birdsEye',
    },
  },
  setup() {
    return {}
  },
})
</script>

<style lang="scss" scoped>
.circuit-detail-map-image {
  &__svg {
    width: 100%;
  }
}
</style>

<style lang="scss">
.circuit-detail-map-image {
  &--mode {
    &-birdsEye path {
      stroke-width: 2px;
    }

    &-battle path {
      stroke-width: 0.25px;
    }

    &-focus path {
      stroke-width: 0.1px;
    }
  }
}
</style>
